'use client';
import type {NavLink} from '@olympus-frontend/tenant-config';
import {usePathname} from 'next/navigation';
import {useTranslation} from 'react-i18next';
import {trackHeaderTabClick} from '../../analytics';
import {externalLinkProps, LinkPending, MenuLink, type MenuLinkType} from '../primitives';
import {isLinkActive} from './activeNav';

interface NavItemProps {
  item: NavLink;
  type?: MenuLinkType;
}

export function NavItem({item, type}: NavItemProps) {
  const {t} = useTranslation();
  const active = isLinkActive(usePathname(), item.href);
  return (
    <MenuLink
      href={item.href}
      active={active}
      onClick={() => {
        trackHeaderTabClick(t(item.labelKey), item.key);
      }}
      type={type}
      {...externalLinkProps(item.href)}
    >
      <LinkPending>{t(item.labelKey)}</LinkPending>
    </MenuLink>
  );
}

NavItem.displayName = 'NavItem';
